/*
  Love'nSpa — landing hébergeurs : transmission de l'attribution au formulaire.

  Le CTA « Créer ma fiche » quitte lovenspa.fr pour l'app de référencement
  (autre domaine). Rien ne traverse tout seul : ni le fbclid posé par Meta sur
  l'URL de la landing, ni les utm_*, ni la session_id du thème. Ce fichier
  recopie ces paramètres sur chaque lien [data-hl-cta] pour que la demande de
  référencement puisse être rattachée au clic publicitaire.

  Paramètres transmis : fbclid, gclid, utm_source, utm_medium, utm_campaign,
  utm_content, utm_term, + lns_sid (= lns_funnel_session, la même clé que
  datalayer-context.liquid et lovenspa-funnel.js).

  La mesure du clic (lns_host_cta_click) n'est pas ici : elle passe par les
  attributs data-lns-event lus par lns-engage.js. Le thème n'appelle jamais
  gtag/fbq. Voir claude/meta-ads-test-hebergeurs.md § 4.1.
*/
(function () {
  'use strict';

  var CLES = ['fbclid', 'gclid', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];

  function sessionId() {
    try {
      var cle = 'lns_funnel_session';
      var v = window.sessionStorage.getItem(cle);
      if (!v) {
        v = 'sess_' + Math.random().toString(36).slice(2) + Date.now().toString(36);
        window.sessionStorage.setItem(cle, v);
      }
      return v;
    } catch (e) { return null; }
  }

  function parametres() {
    var out = {};
    try {
      var src = new URLSearchParams(window.location.search);
      CLES.forEach(function (k) {
        var v = src.get(k);
        if (v) out[k] = v;
      });
    } catch (e) { /* URLSearchParams absent : on ne transmet que la session */ }
    var sid = sessionId();
    if (sid) out.lns_sid = sid;
    return out;
  }

  function decorer(a, params) {
    var href = a.getAttribute('href');
    if (!href || href === '#' || href.indexOf('http') !== 0) return;
    try {
      var url = new URL(href);
      for (var k in params) {
        if (!url.searchParams.has(k)) url.searchParams.set(k, params[k]);
      }
      a.setAttribute('href', url.toString());
    } catch (e) { /* href invalide : on laisse tel quel */ }
  }

  function init() {
    var params = parametres();
    var liens = document.querySelectorAll('a[data-hl-cta]');
    for (var i = 0; i < liens.length; i++) decorer(liens[i], params);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.LNS_HOST_ATTRIBUTION = { params: parametres, init: init };
})();
